import React from "react";
import { useNavigate } from "react-router-dom"; 
import "./Card.css";
import foodImg from "../../assets/food.webp";
import logisticImg from "../../assets/logistics1.avif";
import ecommerceImg from "../../assets/ecommerce1.jpg";
import travelImg from "../../assets/travel.jpg";
import realestateImg from "../../assets/realestate.jpg";
import associateImg from "../../assets/associate.jpg";
import { Row, Col, Card as BootstrapCard } from "react-bootstrap";
import Contact from "../Contact/Contact";

function Card() {
  const navigate = useNavigate(); 

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <>
       <div className="container-fluid mt-5">
       <Row className="mb-3">
              <h2>Our Services</h2>
          </Row>
      <Row className="g-4" >
        <Col md={4} sm={6} xs={12}>
          <BootstrapCard className="custom-card card-slide-top" onClick={() => handleCardClick('/logistic')}>
            <BootstrapCard.Img className="custom-card-img" variant="top" src={logisticImg} />
            <BootstrapCard.Body>
              <BootstrapCard.Title>Logistics </BootstrapCard.Title>
              <BootstrapCard.Text>
                Learn more about logistics and transportation services.
              </BootstrapCard.Text>
            </BootstrapCard.Body>
          </BootstrapCard>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <BootstrapCard className="custom-card card-slide-right" onClick={() => handleCardClick('/food')}>
            <BootstrapCard.Img className="custom-card-img" variant="top" src={foodImg} />
            <BootstrapCard.Body>
              <BootstrapCard.Title>Food</BootstrapCard.Title>
              <BootstrapCard.Text>
                Discover delicious food options and explore food industry trends.
              </BootstrapCard.Text>
            </BootstrapCard.Body>
          </BootstrapCard>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <BootstrapCard className="custom-card card-slide-left" onClick={() => handleCardClick('/traveling')}>
            <BootstrapCard.Img className="custom-card-img" variant="top" src={travelImg} />
            <BootstrapCard.Body>
              <BootstrapCard.Title>Travel</BootstrapCard.Title>
              <BootstrapCard.Text>
                Explore amazing travel destinations and booking services.
              </BootstrapCard.Text>
            </BootstrapCard.Body>
          </BootstrapCard>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <BootstrapCard className="custom-card card-slide-bottom" onClick={() => handleCardClick('/associate')}>
            <BootstrapCard.Img className="custom-card-img" variant="top" src={associateImg} />
            <BootstrapCard.Body>
              <BootstrapCard.Title>Associate</BootstrapCard.Title>
              <BootstrapCard.Text>
              Join our team as an associate and contribute to innovative solutions. 
              </BootstrapCard.Text>
            </BootstrapCard.Body>
          </BootstrapCard>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <BootstrapCard className="custom-card card-slide-top" onClick={() => handleCardClick('/realestate')}>
            <BootstrapCard.Img className="custom-card-img" variant="top" src={realestateImg} />
            <BootstrapCard.Body>
              <BootstrapCard.Title>Real Estate</BootstrapCard.Title>
              <BootstrapCard.Text>
                Discover real estate properties and investment opportunities.
              </BootstrapCard.Text>
            </BootstrapCard.Body>
          </BootstrapCard>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <BootstrapCard className="custom-card card-slide-right" onClick={() => handleCardClick('/ecommerce')}>
            <BootstrapCard.Img className="custom-card-img" variant="top" src={ecommerceImg} />
            <BootstrapCard.Body>
              <BootstrapCard.Title>Ecommerce</BootstrapCard.Title>
              <BootstrapCard.Text>
                Dive into the world of ecommerce and online business growth.
              </BootstrapCard.Text>
            </BootstrapCard.Body>
          </BootstrapCard>
        </Col>
      </Row>
      <Contact/>
    </div>
    </>
  );
}

export default Card;


